import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { CostSettingProfile } from 'lumen/models';
import type { CostValuesView } from 'lumen/utils/net-revenue/cost/types';

export default class CostSettingCostModel extends Model {
  [Type] = 'cost-setting/cost' as const;

  @belongsTo('cost-setting/profile', { async: false, inverse: 'costs' })
  declare profile: CostSettingProfile;

  @attr('cost-values') declare costValues: CostValuesView;
}
